import { render, staticRenderFns } from "./add-list-icon.vue?vue&type=template&id=55e037e4&scoped=true&lang=pug&"
import script from "./add-list-icon.vue?vue&type=script&lang=js&"
export * from "./add-list-icon.vue?vue&type=script&lang=js&"
import style0 from "./add-list-icon.vue?vue&type=style&index=0&id=55e037e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e037e4",
  null
  
)

export default component.exports